import { createSelector } from "reselect";
import { not, either, compose, any, prop } from "ramda";

export default (...apiSelectors) =>
  createSelector(apiSelectors, (...apis) =>
    any(either(compose(not, prop("lastUpdated")), prop("isFetching")), apis)
  );



// WEBPACK FOOTER //
// ./src/core/helpers/createLoadingSelector.js